import { useEffect } from 'react';
import { MultiselectField, useFormField } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  label: string;
  name: string;
  onChange: (value: string[] | undefined) => void;
  options: string[];
  resetKey: number;
  value: string[] | undefined;
};

export const MultiselectFilter = ({ label, name, onChange, options, resetKey, value }: Props) => {
  const { trackingIdPrefix } = useAudienceTray();
  const trackingId = `${label.toLowerCase().split(' ').join('-')}-filter-input`;
  const selectionField = useFormField({ type: 'multiselect', value }, [resetKey]);

  // This useEffect is needed to ensure onChange is passed an array containing all of the selected values (instead of the single string value the user just selected)
  useEffect(() => {
    if (selectionField.value !== value) {
      const filterValue = selectionField.value.length ? selectionField.value : undefined;
      onChange(filterValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionField.value]); // TODO: Exhaustively listing all dependencies will cause an infinite loop. Fixing this requires a larger architectural change.

  return (
    <MultiselectField
      {...selectionField}
      name={name}
      label={label}
      data-trackingid={`${trackingIdPrefix}-${trackingId}`}
    >
      {options?.map((option, index) => {
        return (
          <MultiselectField.Option key={index} value={option}>
            {option}
          </MultiselectField.Option>
        );
      })}
    </MultiselectField>
  );
};
